import { compose, lifecycle } from 'recompose'
import { connect } from 'react-redux'
import LayoutLanding from '../../ui/shared/layout-landing'
import { isLoggedIn, isSessionLoaded } from '../session'
import withLoadingUntilProps from '../../core/withLoadingUntilProps'

const mapStateToProps = (state, props) => ({
  isSessionLoaded: isSessionLoaded(state),
  isLoggedIn: isLoggedIn(state)
})
const withSessionProps = connect(mapStateToProps)

const withGoHomeIfLoggedIn = lifecycle({
  componentDidMount() {
    const { isLoggedIn, history } = this.props
    if (isLoggedIn) history.replace('/explore')
  }
})

export const layoutLandingEnhancer = compose(
  withSessionProps,
  withLoadingUntilProps('isSessionLoaded'),
  withGoHomeIfLoggedIn
)

export default layoutLandingEnhancer(LayoutLanding)



// WEBPACK FOOTER //
// ./src/services/layout/LayoutLanding.js